import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'butterfly-error',
    templateUrl: './error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
    @HostBinding('attr.role')
    role = 'alert';
}
